import { Tag } from "antd";

export function RoundSmallTag({ label = '', color, closable = false, bordered=true }) {
  let style = { borderRadius: '4px', margin: 0 };

  return (
    <Tag color={color} style={style} closable={closable} bordered={bordered}>{label}</Tag>
  );
}
export function RoundMediumTag({ label = '', color, closable = false, bordered=true  }) {
  let style = { borderRadius: '8px', margin: 0 };

  return (
    <Tag color={color} style={style} closable={closable} bordered={bordered}>{label}</Tag>
  );
}
export function RoundTag({ label = '', color, closable = false , bordered=false, style={ borderRadius: '12px', margin: 0 } }) {
  return (
    <Tag color={color} style={{borderRadius: '12px', margin: 0, ...style }} closable={closable} bordered={bordered} >{label}</Tag>
    );
  }
export function BaseTag({ label = '', color, style }) {
  return (
    <Tag color={color} style={{ margin: 0, ...style }}>{label}</Tag>
    );
  }
export function NewTag() {
  return (
    <BaseTag 
      color={'var(--color-blue01)'}
      label={'N'}
      style={{ borderRadius: '12px', fontSize: '8px', padding: '0 2px', height: '12px', lineHeight: 'normal', margin: '0px 0px 1.5px 5px', verticalAlign: 'middle' }}
    />
    );
  }